import CheckItem from "./CheckItem";

const COSTS = [
  "My peace",
  "My focus",
  "My sleep",
  "My money",
  "My confidence",
  "My self-respect",
  "My parenting energy",
  "My ability to show up at work",
  "My ability to enjoy my own life",
];

export default function CostStep({ state, update }) {
  const toggle = (item) => {
    const on = state.s4_costs.includes(item);
    update({
      s4_costs: on ? state.s4_costs.filter((x) => x !== item) : [...state.s4_costs, item],
    });
  };

  return (
    <div>
      <p className="text-[17px] leading-[1.6] text-[color:var(--ks-ink-soft)] mb-5">
        Check everything this is quietly charging you for.
      </p>
      <div className="space-y-3">
        {COSTS.map((c) => (
          <CheckItem
            key={c}
            checked={state.s4_costs.includes(c)}
            label={c}
            onToggle={() => toggle(c)}
            testId={`cost-${slug(c)}`}
          />
        ))}
        <div
          className="ks-check-row items-center"
          data-checked={state.s4_other.trim().length > 0}
          onClick={() => document.getElementById("cost-other-input")?.focus()}
          data-testid="cost-other-row"
        >
          <span className="ks-check-box">
            <svg viewBox="0 0 24 24" fill="none"><path d="M5 12l5 5L20 7" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </span>
          <div className="flex-1">
            <div className="ks-check-label mb-1">Other</div>
            <input
              id="cost-other-input"
              className="ks-input"
              value={state.s4_other}
              onChange={(e) => update({ s4_other: e.target.value })}
              placeholder="Type your own…"
              data-testid="cost-other-input"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function slug(s) {
  return s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}
